import { useEffect, useState } from "react";
import { getProfileByLocale } from "../data/profile";

const DEFAULT_LOCALE = "en";

export const useProfile = () => {
  const [profile, setProfile] = useState(() => getProfileByLocale(DEFAULT_LOCALE));

  useEffect(() => {
    if (typeof window === "undefined") return;
    const stored = window.localStorage.getItem("locale") || DEFAULT_LOCALE;
    setProfile(getProfileByLocale(stored));
    const onLocaleChange = (event) => {
      const next = event?.detail || DEFAULT_LOCALE;
      setProfile(getProfileByLocale(next));
    };
    window.addEventListener("app:locale", onLocaleChange);
    return () => window.removeEventListener("app:locale", onLocaleChange);
  }, []);

  return profile;
};
